<template>
    <div class="isUnbinding">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="头像/昵称">
                <template slot-scope="scope">
                    <div class="imgName">
                        <div class="imgBox">
                            <img :src="scope.row.clientheadimageurl" alt="">
                        </div>
                        <span>{{scope.row.clientnickname}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="totalordercount" label="累计订单数" class-name="center"></el-table-column>
            <el-table-column prop="totalordermoney" label="累计消费金额" class-name="center"></el-table-column>
            <el-table-column prop="bindtime" label="最新绑定时间" class-name="center"></el-table-column>
        </el-table>
        <Page ref="page" :total="total"></Page>
    </div>
</template>
<script>
import {bindUnbindList} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
import Page from '@/base/page/page'
export default {
    name: 'isUnbinding',
    props: ['innerid'],
    data() {
        return {
            total: 200,
            tableData: [],
            params: {
                status: '0',
                innerid: ''
            }
        }
    },
    methods: {
        getUnbindList() {
            bindUnbindList({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'innerid': {
            handler(newV) {
                if (newV) {
                    this.params.innerid = newV
                    this.getUnbindList()
                }
            }
        }
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .isUnbinding{
        .el-table{
            .imgName{
                display: flex;
                align-items: center;
                .imgBox{
                    width: 50px;
                    height: 50px;
                    margin-right: 6px;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                    }
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
        }
    }
</style>